import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getAllDataDictionary } from '@/pages/admins/dataDictionary/api'
import {
  cloneDeep,
  convertToTree,
  getLocalStorage,
  setLocalStorage,
} from '@/utils/tools'

const dataDictionaryCacheKey = 'cache-dataDictionary'
const dataDictionaryCache = getLocalStorage(dataDictionaryCacheKey)
export const fetchGetDataDictionaryAsync = createAsyncThunk(
  'dataDictionary/fetchGetDataDictionaryAsync',
  () =>
    axios
      .get(getAllDataDictionary(dataDictionaryCache?.version ?? ''))
      .then((response) => {
        const resp = response?.data
        if (resp === null) return []
        if (
          resp.data === null &&
          resp.version === dataDictionaryCache?.version
        ) {
          return dataDictionaryCache.data ?? []
        } else {
          setLocalStorage(dataDictionaryCacheKey, resp)
          return resp.data ?? []
        }
      })
      .catch((err) => {
        throw Error('读取字典缓存失败')
      })
)

const dataDictionarySlice = createSlice({
  name: 'dataDictionary',
  initialState: {
    dictionary: [],
    dictionaryTree: [],
  },
  reducers: {
    setDictionary(state, action) {
      state.dictionary = action.payload
    },
    setDictionaryTree(state, action) {
      state.dictionaryTree = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetDataDictionaryAsync.pending, (state) => {
        state.dictionary = []
        state.dictionaryTree = []
      })
      .addCase(fetchGetDataDictionaryAsync.fulfilled, (state, action) => {
        const dictionary = cloneDeep(action.payload || [])
        dictionary?.forEach((c) => {
          c.label = c?.code + '/' + c?.displayText
        })
        const dictionaryTree = convertToTree(dictionary)
        state.dictionary = dictionary
        state.dictionaryTree = dictionaryTree
      })
  },
})

export const { setDictionary, setDictionaryTree } = dataDictionarySlice.actions
export const getDictionary = (state) => state.dataDictionary.dictionary
export const getDictionaryTree = (state) => state.dataDictionary.dictionaryTree
export default dataDictionarySlice.reducer
